import { gql } from '@apollo/client';
export const LOGIN_MUTATION = gql`
  mutation LoginMutation($data: UsersPermissionsLoginInput!) {
    login(input: $data) {
      jwt
      user {
        id
        username
        email
      }
    }
  }
`;
